import { TFunction } from 'i18next';

export type OutsourceInvoiceStatusConfig = {
  code: string;
  getLabel: (t: TFunction) => string;
  color: string;
  queryParam: string;

  providerCostIsFinal: boolean;
};

export const outsourceInvoiceStatusConfig = {
  paid: {
    getLabel: (t: TFunction) => t('paid'),
    code: '0',

    color: '#00D39D',
    queryParam: 'paid',

    providerCostIsFinal: true,
  },

  pendingConfirmation: {
    getLabel: (t: TFunction) => t('pending-confirmation'),
    code: '1',

    color: '#FC8A05',
    queryParam: 'pendingConfirmation',

    providerCostIsFinal: false,
  },

  registered: {
    getLabel: (t: TFunction) => t('registered'),
    code: '2',

    color: '#3503fc',
    queryParam: 'registered',

    providerCostIsFinal: true,
  },

  waitingPayment: {
    getLabel: (t: TFunction) => t('waiting-payment'),
    code: '3',

    color: '#dce703',
    queryParam: 'waitingPayment',

    providerCostIsFinal: true,
  },

  canceled: {
    getLabel: (t: TFunction) => t('canceled'),
    code: '9',

    color: '#F3003A',
    queryParam: 'canceled',

    providerCostIsFinal: true,
  },
};

export const outsourceInvoiceConfigByCode = Object.fromEntries(
  Object.values(outsourceInvoiceStatusConfig).map((config) => [config.code, config]),
) as Record<string, OutsourceInvoiceStatusConfig>;
